import { HABI_API_BASE_URL, getAuthHeaders } from "./habiApi";

/**
 * Traducción on-view de CONTENIDO DINÁMICO (novedades del edificio, etc.) al
 * idioma del residente. El contenido lo escribe el admin en español; acá se
 * traduce vía el endpoint LLM `/api/translate` de propia_agent y se cachea en
 * localStorage por (id, idioma, hash-del-contenido) para no re-traducir ni
 * gastar tokens de más. Nunca throwea: si falla, el caller muestra el original.
 */

const CACHE_PREFIX = "habitia_tr_";

function hashText(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}
function cacheKey(id, lang, text) {
  return `${CACHE_PREFIX}${lang}:${id}:${hashText(text)}`;
}

/**
 * @param {Array<{id:string,title:string,body:string}>} items
 * @param {string} targetLang - "es" | "en" | "pt-BR" ("es" = sin traducción)
 * @returns {Promise<Object>} { [id]: { title, body } } — solo los traducidos
 */
export async function translateItems(items, targetLang) {
  const result = {};
  if (!items || !items.length || !targetLang || targetLang === "es") return result;

  const pending = [];
  for (const it of items) {
    const text = `${it.title || ""}${it.body || ""}`;
    const key = cacheKey(it.id, targetLang, text);
    try {
      const cached = localStorage.getItem(key);
      if (cached) { result[it.id] = JSON.parse(cached); continue; }
    } catch (_) { /* localStorage no disponible: se pide igual */ }
    pending.push({ it, key });
  }
  if (!pending.length) return result;

  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${HABI_API_BASE_URL}/api/translate`, {
      method: "POST",
      headers: { ...headers, "Content-Type": "application/json" },
      body: JSON.stringify({
        target: targetLang,
        items: pending.map(({ it }) => ({
          id: String(it.id),
          title: it.title || "",
          body: it.body || "",
        })),
      }),
    });
    if (res.ok) {
      const data = await res.json();
      (data.items || []).forEach((ti) => {
        const val = { title: ti.title || "", body: ti.body || "" };
        result[ti.id] = val;
        const p = pending.find((x) => String(x.it.id) === String(ti.id));
        if (p) { try { localStorage.setItem(p.key, JSON.stringify(val)); } catch (_) {} }
      });
    }
  } catch (_) { /* silencioso: el caller muestra el original */ }
  return result;
}
